export function formatTime(dateString: string): string {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 === 0 ? hours % 12 : 12;
  // Ensure minutes is always a string
  const formattedMinutes = minutes.toString().padStart(2, '0');
  return `${hours}:${formattedMinutes}${ampm}`;
}

// transform seconds to minutes with no decimal
export function secondsToMinutes(seconds: number): number {
  return Math.floor(seconds / 60);
}

export function getDateString(dateString: string): string {
  const date = new Date(dateString);
  return date.toISOString().slice(0, 10);
}

export function timeToString(date: string | number): string {
  const TimeStamp = new Date(date);
  const hours = TimeStamp.getHours().toString().padStart(2, '0');
  const minutes = TimeStamp.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secondsLeft = seconds % 60;

  let result = '';

  // Append hours if any
  if (hours > 0) {
    result += `${hours}h`;
  }

  // Append minutes if any
  if (minutes > 0) {
    result += `${minutes}’`;
  }

  if (secondsLeft > 0 && hours === 0 && minutes === 0) {
    const roundedMinutes = Math.ceil(secondsLeft / 60);
    if (roundedMinutes > 0) {
      result += `${roundedMinutes}'`;
    }
  }
  return result.trim();
}

export function formatDate(dateNumber: number) {
  const date = new Date(dateNumber);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}.${month}.${year} - ${hours}:${minutes}`;
}

export function formatDateForInput(timestamp: number) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois de 0-11 à 1-12
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
